export default __webpack_public_path__ + "static/media/README.cd5d29ba.md";